import React from 'react';
import { GroupOutlined } from '@ant-design/icons';

import { IBMenuItem } from '@totem/components/ui_components/menus/types';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import { UserProfile } from '@totem/types/user';

export const getSubMenuBilling = (userProfile: UserProfile) => {
  const items: IBMenuItem[] = [
    {
      key: 'billing',
      title: 'Billing',
      label: 'Billing',
      description: 'Billing (Unbilled / Billed)',
      route: '/dashboard/admin/billing',
      icon: <GroupOutlined />,
      hasPermissions: () => {
        return permissions.billingAdministratorIBOrg.hasPermissions(
          userProfile,
        );
      },
    },
    {
      key: 'billingRatesReportPage',
      title: 'Billing Rates',
      label: 'Billing Rates',
      description: 'Billing Rate Administration',
      route: '/dashboard/billingRatesReportPage',
      icon: <GroupOutlined />,
      hasPermissions: () => {
        return permissions.billingAdministratorIBOrg.hasPermissions(
          userProfile,
        );
      },
    },
    {
      key: 'employeeUtilizationPage',
      title: 'Utilization',
      label: 'Utilization',
      description: 'Employee Utilization',
      route: '/dashboard/utilization',
      icon: <GroupOutlined />,
      hasPermissions: () => {
        return permissions.billingAdministratorIBOrg.hasPermissions(
          userProfile,
        );
      },
    },
    {
      key: 'holidays',
      title: 'Holidays',
      label: 'Holidays',
      description: 'Manage Holidays that impact Utilization',
      route: '/dashboard/admin/holidays',
      icon: <GroupOutlined />,
      hasPermissions: () => {
        return permissions.billingAdministratorIBOrg.hasPermissions(
          userProfile,
        );
      },
    },
  ];

  return items.filter((chk) => chk.hasPermissions(userProfile));
};
